module.exports = __webpack_public_path__ + "static/media/submit-btn.1c944fc8.svg";